// src/services/accountSwitcher.js
//
// P3-1 (PROFIL_DERIN_ANALIZ_V2 §5) — Multi-account switcher (Hesap Merkezi).
//
// localStorage'da bu cihazda daha önce giriş yapılmış hesapların HAFİF
// kaydı tutulur: yalnız { uid, username, avatar, lastUsedAt }.
//
// GÜVENLİK KISITLARI (bilinçli):
//   - Şifre, ID token, refresh token, e-posta SAKLANMAZ. Hesaba geçiş
//     her zaman signOut + normal signIn akışıdır (Firebase Auth web SDK'sı
//     aynı anda tek oturum destekler; arka planda oturum yönetimi yok).
//   - Liste yalnız UI kolaylığı: "bu cihazda şu hesaplar kullanıldı"
//     göstergesi. uid/username/avatar zaten public profil verisidir.
//
// Max 5 hesap; doluysa en eski kullanılan düşer (LRU).

const STORAGE_KEY = "mlsa.savedAccounts.v1";
export const MAX_ACCOUNTS = 5;

/**
 * localStorage'da tutulan HAFİF hesap kaydı (yukarıdaki güvenlik kısıtları:
 * token/e-posta/şifre YOK). `readStore` yalnız `uid`'i doğrular; `username`
 * ve `avatar` yazılırken normalize edilir (bkz. `saveAccount`).
 */
export type SavedAccount = {
  uid: string;
  username: string;
  avatar: string;
  lastUsedAt: number;
};

function readStore(): SavedAccount[] {
  try {
    if (typeof window === "undefined") return [];
    const raw = window.localStorage?.getItem(STORAGE_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(arr)) return [];
    return arr.filter(
      (a) => a && typeof a.uid === "string" && a.uid.length > 0
    );
  } catch {
    return [];
  }
}

function writeStore(accounts: SavedAccount[]): void {
  try {
    if (typeof window === "undefined") return;
    window.localStorage?.setItem(STORAGE_KEY, JSON.stringify(accounts));
  } catch {
    /* quota/private mode — sessiz geç */
  }
}

/**
 * Kayıtlı hesaplar, en son kullanılan başta.
 */
export function getSavedAccounts(): SavedAccount[] {
  return readStore().sort(
    (a, b) => (Number(b.lastUsedAt) || 0) - (Number(a.lastUsedAt) || 0)
  );
}

/**
 * Hesabı kaydet/güncelle (idempotent — aynı uid varsa bilgileri tazeler).
 * Max 5; doluysa en eski kullanılan düşer.
 */
export function saveAccount(uid: string, username: string, avatar: string): void {
  if (!uid) return;
  const list = readStore().filter((a) => a.uid !== uid);
  list.push({
    uid: String(uid),
    username: typeof username === "string" ? username.slice(0, 50) : "",
    avatar: typeof avatar === "string" ? avatar.slice(0, 500) : "",
    lastUsedAt: Date.now(),
  });
  list.sort((a, b) => (Number(b.lastUsedAt) || 0) - (Number(a.lastUsedAt) || 0));
  writeStore(list.slice(0, MAX_ACCOUNTS));
}

/**
 * Hesabı listeden kaldır (oturumu ETKİLEMEZ; yalnız UI kaydı silinir).
 */
export function removeAccount(uid: string): void {
  if (!uid) return;
  writeStore(readStore().filter((a) => a.uid !== uid));
}
